import type { Account } from '../types';

interface ExportColumn {
  key: string;
  label: string;
  width?: number;
  align?: 'right';
}

interface VisibleCol {
  key: string;
}

const ALL_EXPORT_COLS: Record<string, ExportColumn> = {
  name: { key: 'name', label: 'Name', width: 32 },
  type: { key: 'type', label: 'Account type', width: 22 },
  detailType: { key: 'detailType', label: 'Detail type', width: 28 },
  novalaBalance: { key: 'novalaBalance', label: 'Novala balance', width: 14, align: 'right' },
  bankBalance: { key: 'bankBalance', label: 'Bank balance', width: 14, align: 'right' },
};

export function buildCoaExport(filtered: Account[], visibleCols: VisibleCol[]) {
  return {
    reportName: 'Chart of accounts',
    columns: visibleCols.map((v) => ALL_EXPORT_COLS[v.key]).filter(Boolean),
    rows: filtered.map((a) => ({
      name: a.name,
      type: a.type,
      detailType: a.detailType ?? '',
      novalaBalance: a.balance ?? '',
      bankBalance: '',
    })),
  };
}